import { InMemoryDbService } from 'angular-in-memory-web-api';
export class LocalDatabase implements InMemoryDbService {
  createDb() {
    let screens = [
        { ScreenID: 1, ScreenName: 'Home Screen', ScreenRoute: '/home' },
        { ScreenID: 2, ScreenName: 'My Profile', ScreenRoute: '/citizen/profile' },
        { ScreenID: 3, ScreenName: 'Report Online', ScreenRoute: '/report/onlinereport' },
        { ScreenID: 3, ScreenName: 'Report Online', ScreenRoute: '/report/newonlinereport' },
        { ScreenID: 4, ScreenName: 'View Crime Map', ScreenRoute: '' },
        { ScreenID: 5, ScreenName: 'View Road Closures', ScreenRoute: '' },
        { ScreenID: 6, ScreenName: 'Find Accident Reports', ScreenRoute: '/report/findaccidentreport' },
        { ScreenID: 7, ScreenName: 'Crime Statistics', ScreenRoute: '' },
        { ScreenID: 8, ScreenName: 'Complaints', ScreenRoute: '/services/complaints' },
        { ScreenID: 8, ScreenName: 'Complaints', ScreenRoute: '/services/complaintsregister' },
        { ScreenID: 9, ScreenName: 'Taxi Complaint', ScreenRoute: '/services/taxicomplaint' },
        { ScreenID: 10, ScreenName: 'Service Request', ScreenRoute: '/services/servicerequestpermission' },
        { ScreenID: 10, ScreenName: 'Service Request', ScreenRoute: '/services/servicerequest' },
        { ScreenID: 11, ScreenName: 'Location Check', ScreenRoute: '/services/location' },
        { ScreenID: 11, ScreenName: 'Location Check', ScreenRoute: '/services/locationcheckcomplaints' },
        { ScreenID: 12, ScreenName: 'Overnight Parking Permit', ScreenRoute: '/permit' },
        { ScreenID: 12, ScreenName: 'Overnight Parking Permit', ScreenRoute: '/permit/overnightparking' },
        { ScreenID: 13, ScreenName: 'Location Check Permission Request', ScreenRoute: '' },
        { ScreenID: 14, ScreenName: 'User Registrataion', ScreenRoute: '' },
        { ScreenID: 15, ScreenName: 'Wanted Persons', ScreenRoute: '' },
        { ScreenID: 16, ScreenName: 'Make a Payment', ScreenRoute: '/payment' },
        { ScreenID: 17, ScreenName: 'Police Alerts', ScreenRoute: '' },
        { ScreenID: 18, ScreenName: 'Newsletter', ScreenRoute: '/alert/newsletter' },
        { ScreenID: 19, ScreenName: 'Register', ScreenRoute: '/citizen/register' },
        { ScreenID: 20, ScreenName: 'AnonymousTips', ScreenRoute: '/services/anonymoustips' },
        { ScreenID: 20, ScreenName: 'SeeSaySomething', ScreenRoute: '/services/something' },
        { ScreenID: 22, ScreenName: 'Alarm Registration', ScreenRoute: '/services/registeralarm' },
        { ScreenID: 23, ScreenName: 'Faq', ScreenRoute: '/others/faq' },
        { ScreenID: 24, ScreenName: 'contactus', ScreenRoute: '/others/contactus' },
        { ScreenID: 26, ScreenName: 'crimecodedmap', ScreenRoute: '/map/crimecodedmap' },
        { ScreenID: 30, ScreenName: 'Alarm Renewal', ScreenRoute: '/services/alarm' },
        { ScreenID: 30, ScreenName: 'Alarm Renewal', ScreenRoute: '/services/alarmrenewal' },
        { ScreenID: 31, ScreenName: 'Disclaimer', ScreenRoute: '/others/disclaimer' },
        { ScreenID: 32, ScreenName: 'Public Data', ScreenRoute: '/permit/publicdata' },
        { ScreenID: 33, ScreenName: 'OpenRecords Request', ScreenRoute: '/report/Openrecordrequest' },
        { ScreenID: 1000, ScreenName: 'LayOut', ScreenRoute: '' }
    ];
    return { screens };
  }
}




// WEBPACK FOOTER //
// D:/NewPhoenixScrum/PhoenixScrum/Main/CitizenSevicesEx/CSClient/CSClient/client/app/core/localdatabase.ts